import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  font-weight: 400;\n  font-family: ",
        ";\n  color: ",
        ";\n  text-align: left;\n  height: 100%;\n\n  .iframe-holder {\n    height: 100%;\n\n    svg {\n      position: fixed;\n      top: 50%;\n      left: 50%;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 8px 0 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  margin-bottom: 32px;\n\n  @media (min-width: ",
        ") {\n    text-align: ",
        ";\n    margin-bottom: 24px;\n  }\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    ",
        "\n    margin-bottom: 32px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  div {\n    margin: 0 auto;\n    font-family: ",
        ";\n    ",
        "\n    text-align: left;\n\n    @media (min-width: ",
        ") {\n      text-align: center;\n    }\n\n    @media (min-width: ",
        ") {\n      text-align: left;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { breakpoints, colors, fonts, pxToCssFont } from "@vfit/shared/themes";
export var Container = styled.div.withConfig({
    componentId: "sc-38b26f99-0"
})(_templateObject(), fonts.exbold, colors.$262626, breakpoints.tablet);
export var Title = styled.div.withConfig({
    componentId: "sc-38b26f99-1"
})(_templateObject1(), pxToCssFont(30, 38), breakpoints.tablet, function(param) {
    var textAlign = param.textAlign;
    return textAlign || "center";
}, breakpoints.desktop, pxToCssFont(36, 45));
export var Description = styled.div.withConfig({
    componentId: "sc-38b26f99-2"
})(_templateObject2(), fonts.regular, pxToCssFont(18, 24), breakpoints.tablet, breakpoints.desktop);
